<template>
  <section class="home-applications" aria-labelledby="home-applications-title">
    <div class="home-applications__inner">
      <h2 id="home-applications-title">Featured Applications</h2>

      <div class="home-applications__layout">
        <div class="home-applications__row home-applications__row--primary">
          <article class="home-application home-application--research">
            <figure>
              <img src="@/assets/images/research-conservation.jpg" alt="" loading="lazy" decoding="async">
            </figure>
            <div class="home-application__copy">
              <h3>Research &amp; Conservation</h3>
              <p>Monitor ecosystems and collect valuable data.</p>
            </div>
          </article>

          <article class="home-application home-application--infrastructure">
            <figure>
              <img src="@/assets/images/infrastructure-utilities.jpg" alt="" loading="lazy" decoding="async">
            </figure>
            <div class="home-application__copy">
              <h3>Infrastructure &amp; Utilities</h3>
              <p>Protect and inspect critical underwater assets.</p>
            </div>
          </article>
        </div>

        <div class="home-applications__row home-applications__row--secondary">
          <article class="home-application home-application--marinas">
            <figure>
              <img src="@/assets/images/marinas-yacht-clubs.jpg" alt="" loading="lazy" decoding="async">
            </figure>
            <div class="home-application__copy">
              <h3>Marinas &amp; Yacht Clubs</h3>
              <p>Create unforgettable member experiences.</p>
            </div>
          </article>

          <article class="home-application home-application--waterfront">
            <figure>
              <img src="@/assets/images/waterfront-homes.jpg" alt="" loading="lazy" decoding="async">
            </figure>
            <div class="home-application__copy">
              <h3>Waterfront Homes</h3>
              <p>Bring the underwater world to your dock.</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'ApplicationStories' }
</script>

<style lang="scss">
#app .home-applications {
  padding: clamp(92px, 6.8vw, 108px) 0 clamp(96px, 7vw, 112px);
  color: var(--ink);
  background: #fbf8f9;
}

#app .home-applications__inner {
  width: min(calc(100% - 80px), 1360px);
  margin: 0 auto;
}

#app .home-applications h2 {
  max-width: 10ch;
  margin-bottom: clamp(48px, 4.4vw, 60px);
  color: var(--ink);
  font-size: clamp(3.6rem, 5.8vw, 5.9rem);
  letter-spacing: -0.05em;
}

#app .home-applications__layout {
  display: grid;
  gap: clamp(48px, 4vw, 58px);
}

#app .home-applications__row {
  display: grid;
  min-width: 0;
  gap: clamp(24px, 2.4vw, 34px);
  align-items: start;
}

#app .home-applications__row--primary {
  grid-template-columns: minmax(0, 1.22fr) minmax(360px, 0.78fr);
}

#app .home-applications__row--secondary {
  grid-template-columns: minmax(360px, 0.78fr) minmax(0, 1.22fr);
}

#app .home-application {
  display: grid;
  min-width: 0;
  grid-template-rows: auto auto;
}

#app .home-application figure {
  min-width: 0;
  min-height: 0;
  margin: 0;
  overflow: hidden;
  background: var(--navy);
}

#app .home-application img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(0.78) contrast(1.03) brightness(0.88);
}

#app .home-applications__row--primary figure {
  height: clamp(340px, 27vw, 370px);
}

#app .home-applications__row--secondary figure {
  height: clamp(280px, 22vw, 310px);
}

#app .home-application__copy {
  padding-top: 20px;
}

#app .home-application h3 {
  max-width: 14ch;
  margin-bottom: 12px;
  color: var(--ink);
  font-size: clamp(2.2rem, 2.65vw, 2.9rem);
  line-height: 1;
}

#app .home-application p {
  max-width: 34ch;
  margin: 0;
  color: var(--copy-dark);
  font-size: clamp(1rem, 1.05vw, 1.1rem);
  line-height: 1.52;
}

#app .home-application--research img { object-position: 47% 48%; }

#app .home-application--research h3 {
  max-width: none;
  white-space: nowrap;
}

#app .home-application--infrastructure img { object-position: 60% 50%; }
#app .home-application--infrastructure h3 { max-width: 15ch; }
#app .home-application--marinas img { object-position: 40% 52%; }
#app .home-application--waterfront img { object-position: 58% 54%; }

@media (max-width: 1100px) {
  #app .home-applications__inner {
    width: calc(100% - 60px);
  }

  #app .home-applications__row--primary {
    grid-template-columns: minmax(0, 1.12fr) minmax(300px, 0.88fr);
  }

  #app .home-applications__row--secondary {
    grid-template-columns: minmax(300px, 0.88fr) minmax(0, 1.12fr);
  }

  #app .home-applications__row--primary figure {
    height: 330px;
  }

  #app .home-applications__row--secondary figure {
    height: 280px;
  }
}

@media (max-width: 820px) {
  #app .home-applications { padding: 88px 0 100px; }
  #app .home-applications__inner { width: calc(100% - 40px); }
  #app .home-applications h2 {
    margin-bottom: 56px;
    font-size: clamp(3.2rem, 14vw, 5rem);
  }

  #app .home-applications__layout {
    gap: 46px;
  }

  #app .home-applications__row,
  #app .home-applications__row--primary,
  #app .home-applications__row--secondary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }

  #app .home-applications__row--primary figure {
    height: 300px;
  }

  #app .home-applications__row--secondary figure {
    height: 260px;
  }

  #app .home-application h3 {
    font-size: clamp(1.95rem, 4.4vw, 2.3rem);
  }

  #app .home-application--research h3 { white-space: normal; }
}

@media (max-width: 620px) {
  #app .home-applications { padding: 82px 0 94px; }

  #app .home-applications h2 {
    margin-bottom: 50px;
  }

  #app .home-applications__layout {
    gap: 50px;
  }

  #app .home-applications__row,
  #app .home-applications__row--primary,
  #app .home-applications__row--secondary {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  #app .home-applications__row--primary figure,
  #app .home-applications__row--secondary figure,
  #app .home-application figure {
    height: auto;
    aspect-ratio: 16 / 10;
  }

  #app .home-application--infrastructure figure {
    aspect-ratio: 16 / 9;
  }

  #app .home-application__copy,
  #app .home-application--research .home-application__copy {
    padding-top: 20px;
  }

  #app .home-application h3,
  #app .home-application--research h3,
  #app .home-application--waterfront h3 {
    max-width: 13ch;
    font-size: clamp(2.5rem, 10.8vw, 3.3rem);
  }

  #app .home-application p,
  #app .home-application--research p {
    max-width: 34ch;
    font-size: 1.04rem;
  }
}
</style>
